// extracted by mini-css-extract-plugin
export default {"scroll":"PdfPlayer_scroll__plsVV","pdfDocument":"PdfPlayer_pdfDocument__NqTIJ","pdfDocumentAdditional":"PdfPlayer_pdfDocumentAdditional__ODJs9"};